export default __webpack_public_path__ + "4ec4dd3fc095cee0122328fd822ea3c6.png";